<template lang="html">
  <div class="diak_tanfolyam-component">
  <v-container>
    <v-progress-linear
          v-if="loading"
          indeterminate
          color="red"
    ></v-progress-linear>
    <v-simple-table v-if="student_course_details != ''">
      <thead>
        <tr>
          <th class="text-left">Tanfolyam száma</th>
          <th class="text-left">Helyszín</th>
          <th class="text-left">Tanfolyam típus</th>
          <th class="text-left">Tanuló azonosító</th>
          <th class="text-left">Tanfolyam kezdete</th>
          <th class="text-left">Tanfolyam vége</th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in student_course_details" :style="item.status == 'Preregistred' ? {'background': '#FFF3E0'} : ''">
          <td style='min-width: 150px'>
            <input type="text"
              size="12"
              v-model="item.course_number"
              
              @change="course_data_change = true"
            >
          </td>
          <td style='min-width: 150px'>{{ item.place_name }}</td>
          <td style='min-width: 150px'>{{ item.course_pattern }}</td>
          <td style='min-width: 130px'>
            <input type="text"
              size="18"
              v-model="item.course_student_id"
              
              @change="course_data_change = true"
            >
          </td>
          <td style='min-width: 140px'>
            <input type="text"
              size="10"
              v-model="item.start_date"
              v-mask="'####-##-##'"
              :disabled="item.training_type != 'Elearning'"
              @change="course_data_change = true"
            >
          </td>
          <td style='min-width: 120px'>
            <input type="text"
              size="10"
              v-model="item.end_date"
              v-mask="'####-##-##'"
              :disabled="item.training_type != 'Elearning'"
              @change="course_data_change = true"
            >
          </td>
          <td>
            <v-btn
            v-if="contract_type != 4"
            color="primary"
            @click="jellapDetails(item.course_id, item.course_student_id, item.course_data_id, item.training_type)"
            rounded
            outlined
            :disabled="contract_type == 6 || contract_type == 4 || item.status == 'Preregistred'"
            >
            Jellap
            </v-btn>
            <v-btn
            v-if="contract_type == 4"
            color="primary"
            rounded
            outlined
            @click="pallasz_id = null, course_data_id = item.course_data_id, course_id = item.course_id, gki_vn_datas = [], gki_kartya_datas = [], gkiJellapDetails()"
            >
            Pallasz
            </v-btn>
          </td>
          <td>
            <v-btn
              v-if="item.status == 'Preregistred'"
              rounded
              color="primary"
              outlined
              @click="etitanPayments(), finalize_to_course_confirm = true, selected_course = item.course_id, course_id_to_add = item.course_id, course_data_id_to_add = item.course_data_id, course_number_to_add = item.course_number, roster_status_to_add = item.roster_status, course_type_to_select = item.course_pattern_id"
            >
              Véglegesít
            </v-btn>
            <v-menu v-if="item.status != 'Preregistred'">
            <template v-slot:activator="{ on }">
              <v-btn
                icon
                v-on="on"
                :loading="dots_loading"
              >
                <v-icon>mdi-dots-vertical</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="downloadContract(item.course_id)">
                <v-list-item-title>
                  Szerződés letöltés
                </v-list-item-title>
                <v-list-item-icon>
                  <v-icon>file_download</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="signContract(item.course_id)" :disabled="item.contract_sign_time || !item.contract_sign">
                <v-list-item-title>
                  Szerződés aláírás
                </v-list-item-title>
                <v-list-item-icon>
                  <v-icon>create</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="parentSign(item.course_id)" :disabled="item.parent_sign_time" v-if="!check18(item.contract_date, item.birthdate)">
                <v-list-item-title>
                  Szülői aláírás
                </v-list-item-title>
                <v-list-item-icon>
                  <v-icon>escalator_warning</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item @click="contract_upload_dialog = true, checkUploadedFile()" :disabled="item.contract_sign_time">
                <v-list-item-title>
                  Szerződés feltöltés
                </v-list-item-title>
                <v-list-item-icon>
                  <v-icon>cloud_upload</v-icon>
                </v-list-item-icon>
              </v-list-item>
              <v-list-item :disabled="item.reg_form_status != 'Sent' && item.training_type != 'WithoutCourse' && !item.nkh_transaction_id" @click="kepzesi_dialog = true, pallasz_id = item.pallasz_id, kokeny_id = item.kokeny_id, school_id = item.driving_school_id, kepzesiAdatokCheck(item.pallasz_id, item.kokeny_id, item.course_id, item.course_student_id, item.course_data_id)">
                <v-list-item-title>
                  Képzési adatok
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="contract_type != 6" @click="downloadTolmacsos(item.course_id)">
                <v-list-item-title>
                  Tolmácsos kérelem
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="contract_type != 6" @click="downloadSzobeli(item.course_id)">
                <v-list-item-title>
                  Szóbeli kérelem
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="contract_type != 6 && nkh_course_type_id == 109" @click="downloadKedvezmeny(item.course_id)">
                <v-list-item-title>
                  Igazolás (állami támogatás)
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="!item.exam_advance_booking && contract_type != 6 && contract_type != 4" @click="preg_course_data_id = item.course_data_id, preg_course_student_id = item.course_student_id, preg_driving_school_id = item.driving_school_id, vdPayments(), preg_dialog = true">
                <v-list-item-title>
                  Vizsga előjegyzés
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.exam_advance_booking" @click="preg_del_id = item.exam_advance_booking, preg_del_dialog = true">
                <v-list-item-title>
                  Előjegyzés törlése
                </v-list-item-title>
              </v-list-item>
              <v-list-item @click="etitan_dialog = true, selected_training_type = item.training_type, sel_kieg_tanfolyam = null, selected_vizsgafelk = null, titan_course_data_id = item.course_data_id, course_student_id = item.course_student_id, titan_course_id = item.course_id, titan_data_mod = null, nyelv = 'default'">
                <v-list-item-title>
                  E-titán
                </v-list-item-title>
              </v-list-item>
              <!--
              <v-list-item v-if="item.training_type == 'Elearning'" @click="getXML">
                <v-list-item-title>
                  E-titán XML
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-if="item.training_type == 'Elearning'" @click="openEtitan">
                <v-list-item-title>
                  XML feltöltés
                </v-list-item-title>
              </v-list-item>
              -->
            </v-list>
          </v-menu>
          </td>
          <td>
            <v-btn
            @click="modCourseDetails(item.course_id, item.course_data_id, item.course_number, item.course_student_id, item.start_date, item.end_date)"
            color="primary"
            rounded
            outlined
            :disabled="!course_data_change"
            >
            Mentés
            </v-btn>
          </td>
          <td>
            <v-btn outlined fab small color="red" @click="del_course_dialog = true, course_del_id = item.course_id, courses_data_del_id = item.course_data_id">
              <v-icon>delete</v-icon>
            </v-btn>
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-row>
    <v-col class="text-center" cols="12">
    <v-btn
      rounded
      color="primary"
      @click="add_course_dialog=true, selected_course=null, searchCourses()"
    >
    Tanfolyamhoz rendelés
    <v-icon dark>mdi-plus</v-icon>
    </v-btn>
    </v-col>
  </v-row>
  
  <v-row justify="center">
    <v-dialog v-model="add_course_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
        <v-toolbar-title>Tanfolyam választása</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="add_course_dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
        <v-card-text>
          <v-container>
          <v-row>
            <v-text-field
              v-model="tanfolyam_search_text"
              @keyup.enter="searchCourses()"
              @click:clear="searchCourses()"
              label="Tanfolyamok keresése"
              outlined
              clearable
              prepend-inner-icon="search"
            ></v-text-field>
          </v-row>
            <v-data-table
            v-if="courses_to_add"
            :headers="add_course_header"
            :items="courses_to_add"
            item-key="course_id"
            :mobile-breakpoint='NaN'
            >
            <template v-slot:item="{ item }">
              <tr>
              <td style='min-width: 150px'>{{item.course_number}}</td>
              <td style='min-width: 130px'>{{item.course_start}}</td>
              <td style='min-width: 120px'>{{item.course_end}}</td>
              <td style='min-width: 140px'>{{item.course_type}}</td>
              <td style='min-width: 160px'>{{item.place_name}}</td>
              <td style='min-width: 100px'>{{item.count}} / {{item.preg_count}}</td>
              <td>
                <v-btn @click="etitanPayments(), selected_course = item.course_id, course_id_to_add = item.course_id, course_number_to_add = item.course_number, course_type_to_select = item.course_pattern, add_to_course_confirm = true" outlined small fab color="primary">
                  <v-icon>add</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          </v-data-table>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>

    <v-dialog v-model="add_to_course_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan hozzáadja a tanulót a tanfolyamhoz?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        <v-checkbox
          v-model="prereg"
          label="Előregisztráció"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="addStudentCourse(), add_to_course_confirm = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && !prereg && (course_type_to_select != 87 && course_type_to_select != 88 && course_type_to_select != 89 && course_type_to_select != 91)">Igen</v-btn>
        <v-btn color="red" outlined @click="add_to_course_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="finalize_to_course_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan hozzáadja a tanulót a tanfolyamhoz?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="pregStudents(), finalize_to_course_confirm = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && (course_type_to_select != 87 && course_type_to_select != 88 && course_type_to_select != 89 && course_type_to_select != 91)">Igen</v-btn>
        <v-btn color="red" outlined @click="finalize_to_course_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  </v-container>

  <div v-if="jellap_show">
  <DiakJellap></DiakJellap>
  </div>
  <div v-if="gki_show">
    <v-container>
      <v-form
        ref="gki_card_form"
        v-model="valid"
        lazy-validation
      >
     <v-row>
      <v-col cols="12" md="6">
        <v-select
          v-model="kartya_kiallitas_value"
          :items="kartya_kiallitas"
          label="Igazolvány kiállítását kéri?"
          outlined
          :rules="kartyaRules"
        ></v-select>
      </v-col>
     </v-row>
     <v-row>
      <v-col cols="12" md="12">
        <v-select
          v-model="kartya_atvetel_value"
          :items="kartya_atvetel"
          label="Igazolvány átvétel módja"
          outlined
          :disabled="kartya_kiallitas_value == '2'"
          :rules="[kartyaAtvetelRules]"
        ></v-select>
      </v-col>
     </v-row>
     <v-row>
       <v-col md="2">
       <v-btn
         color="primary"
         rounded
         @click="saveGkiJellapDetails()"
         :disabled="!valid"
       >
       Mentés
       <v-icon right>save</v-icon>
       </v-btn>
       </v-col>
       <v-col md="3" lg="2">
       <v-btn
         v-if="!pallasz_id"
         color="primary"
         rounded
         @click="GKIJellapUpload()"
         :loading="preloader"
         :disabled="preloader || !valid"
       >
       Feltöltés
       <v-icon right>cloud_upload</v-icon>
       </v-btn>
       <v-btn
         v-if="pallasz_id"
         color="primary"
         rounded
         @click="GKIJellapMod()"
         :loading="preloader"
         :disabled="preloader || !valid || pallasz_id_status == 'Sent'"
       >
       Módosítás
       <v-icon right>cloud_upload</v-icon>
       </v-btn>
       </v-col>
       <v-col md="2">
       <v-btn
         color="primary"
         rounded
         :disabled="!pallasz_id || preloader"
         :loading="preloader"
         @click="GKIJellapDownload()"
       >
       Letöltés
       <v-icon right>cloud_download</v-icon>
       </v-btn>
       </v-col>
      <v-col md="2">
      <v-btn
        v-if="pallasz_id_status != 'Sent'"
        class="white--text"
        color="red"
        rounded
        @click="adatszolg_dialog = true"
        :disabled=" !pallasz_id || pallasz_id_status == 'Sent' || send_preloader"
        :loading="send_preloader"
      >
      Beküldés
      <v-icon right>apartment</v-icon>
      </v-btn>
      <v-btn
        v-if="pallasz_id_status == 'Sent'"
        class="white--text"
        color="green"
        rounded
        @click="checkAdatlapIktat()"
        :disabled="send_preloader"
        :loading="send_preloader"
      >
      Ellenőrzés
      <v-icon right>apartment</v-icon>
      </v-btn>
      </v-col>
      <v-col md="3">
      <v-btn
        v-if="pallasz_id_status != 'Sent' && admin"
        class="white--text"
        color="red"
        outlined
        @click="bekuldStatusz()"
        :disabled=" !pallasz_id || pallasz_id_status == 'Sent' || send_preloader"
        :loading="send_preloader"
      >
      Beküldöttre állít
      </v-btn>
      </v-col>
      <v-col md="3">
      <v-btn
        v-if="pallasz_id_status != 'Sent' && admin"
        class="white--text"
        color="red"
        outlined
        @click="saveTanf()"
        :disabled="preloader || !pallasz_id || pallasz_id_status == 'Sent'"
        :loading="send_preloader"
      >
      Tanfolyam rögzítés
      </v-btn>
      </v-col>
     </v-row>
     </v-form>
     <p v-if="pallasz_id_status == 'Sent'">Az adatlap már beküldésre került a KAV-hoz, ezért nem módosítható!</p>
     <v-row>
     <v-col md="5" lg="4" v-if="gki_vn_datas != ''">
      <v-btn
        class="white--text"
        color="red"
        outlined
        :disabled="gki_vn_loading"
        :loading="gki_vn_loading"
        @click="vn_dialog = true"
      >
      Vizsgamentes képzés igazolása
      </v-btn>
      </v-col>
      <v-col md="3" v-if="gki_kartya_datas != ''">
      <v-btn
        class="white--text"
        color="green"
        outlined
        :disabled="gki_kartya_loading"
        :loading="gki_kartya_loading"
        @click="kartya_dialog = true"
      >
      Okmánydíj befizetése
      </v-btn>
      </v-col>
      </v-row>
    </v-container>
    <v-container name="karton_azonosító">
      <div class="subtitle-1 black--text">Régi GKI karton azonosító</div>
      <v-divider></v-divider><br>
      <v-col cols="12" md="4">
      <v-btn
        color="primary"
        rounded
        disabled
        :loading="preloader"
        @click="GkiKartonAz()"
      >
      generálás
      </v-btn>
      </v-col>
      <v-col cols="12" md="4">
        {{gki_karton_az}} {{gki_karton_date}}
      </v-col>
    </v-container>
  </div>

  <v-dialog
      v-model="adatszolg_dialog"
      width="500"
    >
      <v-card>

        <v-card-text class="subtitle-1">
        <v-container>
          Biztosan beküldi az adatlapot?<br>
          (A jelentkezési lap a hatósági beküldést követően nem módosítható!)
        </v-container>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="red"
            text
            @click="adatszolg_dialog = false"
          >
            Mégsem
          </v-btn>
          <v-btn
            color="green"
            text
            @click="bekuldJellap()"
          >
            Beküldés
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  <v-dialog v-model="pallasz_dialog" persistent max-width="600">
    <v-card>
      <v-container>
      <p><b>Szeretné az adatokat a Pallaszban is rögzíteni?</b></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="pallasz_dialog = false, GkiTanfUpdate()">igen</v-btn>
        <v-btn color="red" outlined @click="pallasz_dialog = false">nem</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>

  <v-dialog v-model="vn_dialog" persistent max-width="600">
    <v-card>
      <v-container>
      <p><b>Biztosan leigazolja a tanuló képzését?</b></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="gkiVnIgazolas()" :disabled="gki_vn_loading" :loading="gki_vn_loading">igen</v-btn>
        <v-btn color="red" outlined @click="vn_dialog = false" :disabled="gki_vn_loading">nem</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>

  <v-dialog v-model="kartya_dialog" persistent max-width="600">
    <v-card>
      <v-container>
      <p><b>Biztosan befizeti a tanuló GKI kártya díját?</b></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined :disabled="gki_kartya_loading" :loading="gki_kartya_loading" @click="gkiKartyaBefiz()">igen</v-btn>
        <v-btn color="red" outlined @click="kartya_dialog = false" :disabled="gki_kartya_loading">nem</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>

  <v-dialog v-model="befogado_print_dialog" persistent max-width="600">
    <v-card>
      <v-container>
      <p><b>{{ response_text }}</b></p>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="befogadoPrint()">letöltés</v-btn>
        <v-btn color="red" outlined @click="befogado_print_dialog = false">bezár</v-btn>
      </v-card-actions>
      </v-container>
    </v-card>
  </v-dialog>

  <v-snackbar v-model="response_snackbar" bottom :color="snackbar_color">
    {{ response_text }}
    {{nevsor_response_text}}
    <v-btn :color="snackbar_close" text @click="response_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-snackbar v-model="gki_snackbar" bottom :color="response_success == 'error' ? 'error' : ''" :timeout="0">
    {{ response_text }}
    <v-btn :color="response_success == 'error' ? '' : 'pink'" text @click="gki_snackbar = false">
      Bezár
    </v-btn>
  </v-snackbar>

  <v-dialog v-model="etitan_dialog" persistent max-width="900">
    <v-card>
      <v-card-title>
        <h4>Válasszon egy műveletet!</h4>
      </v-card-title>
      <v-card-text class="pt-4">
        <v-row>
          <v-col cols="12" md="4" v-if="!titanId">
          <v-btn class="mb-4" v-if="contract_type != 4 && !titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || nyelv == 'default'" @click="etitanKatUpload()">Kategóriás tanuló - feltöltés</v-btn>
          <v-btn class="mb-4" v-if="!titanId && selected_training_type != 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || nyelv == 'default'" @click="etitanVfUpload()">Kieg. képzéses tanuló - feltöltés</v-btn>
          <v-btn class="mb-4" v-if="contract_type == 4 && !titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || nyelv == 'default'" @click="etitanGKIUpload()">Szaktanf. tanuló - feltöltés</v-btn>
          <v-select
            v-model="nyelv"
            :items="nyelv_items"
            label="Tananyag nyelve"
            outlined
            rounded
            dense
          ></v-select>
          <!--
          <v-checkbox
            v-if="!titanId && selected_training_type != 'Elearning'"
            v-model="euVf"
            label="EÜ tanfolyam"
          ></v-checkbox>
        -->
          </v-col>
        </v-row>

          <v-expansion-panels v-if="titanId">
            <v-expansion-panel v-if="selected_training_type == 'Elearning'">
              <v-expansion-panel-header class="title font-weight-regular">
                Tananyag rendelés
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="nyelv"
                    :items="nyelv_items"
                    label="Tananyag nyelve"
                    outlined
                    rounded
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || nyelv == 'default'" @click="titan_order_confirm = true, etitanPayments()">Kategóriás tananyag</v-btn>
                  <v-btn v-if="contract_type == 4 && titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || nyelv == 'default'" @click="gki_order_confirm = true, etitanPayments()">GKI tananyag</v-btn>
                </v-col>
                <v-col cols="12" md="4" v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'">
                  <v-btn v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'" color="purple darken-2" outlined rounded :disabled="titan_loading_bar" @click="titan_katpot_order_confirm = true, etitanPayments()">Kategóriás pótóra</v-btn>
                </v-col>
                <v-col cols="12" md="4" v-if="contract_type == 4 && titanId && selected_training_type == 'Elearning'">
                  <v-btn v-if="contract_type == 4 && titanId && selected_training_type == 'Elearning'" color="purple darken-2" outlined rounded :disabled="titan_loading_bar" @click="titan_gkipot_order_confirm = true, etitanPayments()">GKI pótóra</v-btn>
                </v-col>
                </v-row>
                <v-row>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar" @click="etitanKatStat()">
                    Haladási Adatok
                    <v-icon
                      right
                      dark
                    >
                      equalizer
                    </v-icon>
                  </v-btn>
                </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="selected_training_type != 'Elearning'">
              <v-expansion-panel-header class="title font-weight-regular">
                Vizsgafelkészítő rendelés
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                <v-col cols="12" md="4">
                  <v-select
                    v-model="nyelv"
                    :items="nyelv_items"
                    label="Tananyag nyelve"
                    outlined
                    rounded
                    dense
                  ></v-select>
                  </v-col>
                  <v-col cols="12" md="4" v-if="titanId && selected_training_type != 'Elearning'">
                  <v-select
                    v-if="titanId && selected_training_type != 'Elearning'"
                    v-model="selected_vizsgafelk"
                    :items="vizsgafelk_items"
                    label="Vizsgafelkészítő"
                    outlined
                    rounded
                    dense
                  ></v-select>
                  </v-col>
                  <v-col cols="12" md="4">
                    <v-btn v-if="titanId && selected_training_type != 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || !selected_vizsgafelk || nyelv == 'default'" @click="vizsgafelk_order_confirm = true, etitanPayments()">megrendelés</v-btn>
                  </v-col>
                </v-row>
                <v-row>
                <v-col cols="12" md="3" v-if="titanId && selected_training_type != 'Elearning'">
                  <v-btn color="purple darken-2" outlined rounded :disabled="titan_loading_bar" @click="vizsgafelk_pot_order_confirm = true, etitanPayments()">Vizsgafelk. pótóra</v-btn>
                </v-col>
                </v-row>
                <v-row>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId && selected_training_type != 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar" @click="etitanVfKatStat()">
                    Haladási Adatok
                    <v-icon
                      right
                      dark
                    >
                      equalizer
                    </v-icon>
                  </v-btn>
                </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="contract_type != 4 && selected_training_type == 'Elearning'">
              <v-expansion-panel-header class="title font-weight-regular">
                Kiegészítő tanfolyam
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                <v-col cols="12" md="5" v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'">
                  <v-select
                    v-if="titanId && selected_training_type == 'Elearning'"
                    v-model="sel_kieg_tanfolyam"
                    :items="kieg_tanfolyamok"
                    label="Kiegészítő tanfolyam"
                    outlined
                    rounded
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="3" v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'">
                <v-btn v-if="titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar || !sel_kieg_tanfolyam" @click="titan_kieg_order_confirm = true, etitanPayments()">megrendelés</v-btn>
                </v-col>
                <v-col cols="12" md="3">
                <v-btn v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'" color="purple darken-2" outlined rounded :disabled="titan_loading_bar" @click="kieg_pot_order_confirm = true, etitanPayments()">Vizsgafelk. pótóra</v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn v-if="contract_type != 4 && titanId && selected_training_type == 'Elearning'" color="primary" outlined rounded :disabled="titan_loading_bar" @click="etitanKiegKatStat()">
                    Kieg. tanf. Adatok
                    <v-icon
                      right
                      dark
                    >
                      equalizer
                    </v-icon>
                  </v-btn>
                </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel v-if="titanId">
              <v-expansion-panel-header class="title font-weight-regular">
                Egyéb műveletek
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId" color="primary" outlined rounded :disabled="titan_loading_bar" @click="etitanUsername()">
                    Felhasználónév
                    <v-icon
                      right
                      dark
                    >
                      perm_identity
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId" color="primary" outlined rounded :disabled="titan_loading_bar" @click="etitanPenzugy()">
                    Pénzügyek
                    <v-icon
                      right
                      dark
                    >
                      euro_symbol
                    </v-icon>
                  </v-btn>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId" color="purple darken-2" outlined rounded :disabled="titan_loading_bar" @click="titan_postorder_confirm = true, etitanPayments()">Utólagos megrendelés</v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="8">
                  <v-select
                    v-if="titanId"
                    v-model="titan_data_mod"
                    :items="titan_data_mod_types"
                    label="Adatmódosítások"
                    outlined
                    rounded
                    dense
                  ></v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-btn v-if="titanId" color="primary" outlined rounded :disabled="titan_loading_bar || !titan_data_mod" @click="etitanModFunctions()">
                    Rögzítés
                    <v-icon
                      right
                      dark
                    >
                      save
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row v-if="titanId">
                <v-col cols="12" md="6">
                <v-btn color="red" outlined :disabled="titan_loading_bar" @click="etitanDelete()">Összerendelés törlése
                  <v-icon
                    right
                    dark
                  >
                    delete
                  </v-icon>
                </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                <v-btn color="red" outlined @click="titan_close_confirm = true, titan_close_reason = null" :disabled="titan_loading_bar">Képzést abbahagyta
                  <v-icon
                    right
                    dark
                  >
                    highlight_off
                  </v-icon>
                </v-btn>
                </v-col>
              </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

      </v-card-text>
      <v-card-actions>
        <v-col cols="8">
        <v-progress-linear v-if="titan_loading_bar" v-model="titan_loading" color="red" height="6"></v-progress-linear>
        </v-col>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="etitan_dialog = false, euVf = false">Bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_order_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan megrendeli a tananyagot?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>

        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKatOrder(), titan_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_postorder_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan megrendeli a tananyagot?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          dense
        >
          <template v-slot:selection="data">
            <!-- HTML that describe how select should render selected items -->
            {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
          </template>
          <template v-slot:item="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
          </template>
        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanPostOrderNew(), titan_postorder_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_postorder_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="gki_order_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan megrendeli a GKI tananyagot?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
          <template v-slot:selection="{ item, index }">
            <v-chip>
              <span>{{ item.amount }} - {{ item.invoice_date }}</span>
            </v-chip>
          </template>

          <template v-slot:item="{ active, item, attrs, on }">
            <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
              <v-list-item-action>
              <v-checkbox :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanGKIOrder(), gki_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="gki_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_katpot_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan megrendeli a pótórát?</b>
      <br><br>
      <v-select
        v-model="sel_payment"
        :items="titan_payments"
        label="Befizetés hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        multiple
      >
      <template v-slot:selection="{ item, index }">
        <v-chip>
          <span>{{ item.amount }} - {{ item.invoice_date }}</span>
        </v-chip>
      </template>

      <template v-slot:item="{ active, item, attrs, on }">
        <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
          <v-list-item-action>
          <v-checkbox :input-value="active"></v-checkbox>
          </v-list-item-action>
          <v-list-item-content>
            <v-list-item-title>
              {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_learning"
        label="Tandíjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKatPotOrder(), titan_katpot_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_katpot_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_gkipot_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan megrendeli a pótórát?</b>
      <br><br>
      <v-select
        v-model="sel_payment"
        :items="titan_payments"
        label="Befizetés hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_learning"
        label="Tandíjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanGKIPotOrder(), titan_gkipot_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_gkipot_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="vizsgafelk_pot_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan megrendeli a pótórát?</b>
      <br><br>
      <v-select
        v-model="sel_payment"
        :items="titan_payments"
        label="Befizetés hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_learning"
        label="Tandíjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKiegPotOrder(), vizsgafelk_pot_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="vizsgafelk_pot_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="kieg_pot_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan megrendeli a pótórát?</b>
      <br><br>
      <v-select
        v-model="sel_payment"
        :items="titan_payments"
        label="Befizetés hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_learning"
        label="Tandíjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKiegTanfPotOrder(), kieg_pot_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="kieg_pot_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_kieg_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan megrendeli a kiegészítő tanfolyamot?</b>
      <br><br>
      <v-select
        v-model="sel_payment"
        :items="titan_payments"
        label="Befizetés hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        multiple
      >
        <template v-slot:selection="{ item, index }">
          <v-chip>
            <span>{{ item.amount }} - {{ item.invoice_date }}</span>
          </v-chip>
        </template>

        <template v-slot:item="{ active, item, attrs, on }">
          <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
            <v-list-item-action>
            <v-checkbox :input-value="active"></v-checkbox>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>
                {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_learning"
        label="Tandíjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="titan_kieg_order_confirm = false, etitanKatKiegOrder()" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_kieg_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="vizsgafelk_order_confirm" persistent max-width="450">
    <v-card>
      <v-container>
        <b>Biztosan megrendeli a vizsgafelkészítőt?</b>
        <br><br>
        <v-select
          v-model="sel_payment"
          :items="titan_payments"
          label="Befizetés hozzárendelése"
          item-value="payment_id"
          outlined
          rounded
          multiple
        >
          <template v-slot:selection="data">
            <!-- HTML that describe how select should render selected items -->
            {{ data.item.amount }}
          </template>
          <template v-slot:item="data">
            <!-- HTML that describe how select should render items when the select is open -->
            {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
          </template>
        </v-select>
        <v-checkbox
          v-if="admin"
          v-model="free_learning"
          label="Tandíjmentesség"
        ></v-checkbox>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanVfOrder(), vizsgafelk_order_confirm = false" :disabled="titanKatLoading || (!sel_payment || sel_payment == '') && !free_learning">Igen</v-btn>
        <v-btn color="red" outlined @click="vizsgafelk_order_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="reserved_kat_dialog" persistent max-width="800">
    <v-card>
      <v-container>
        <b>Ilyen névvel már szerepel tanuló a rendszerben, kérjük válassza ki, hogy kit rendeljünk hozzá a fiókhoz?</b>
        <br>
        <v-data-table
          :headers="res_gki_headers"
          :items="reserved_gki_studs"
          :items-per-page="5"
          class="elevation-1"
          @click:row="etitanGKIUpdate($event)"
        ></v-data-table>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKatUploadNew(), reserved_kat_dialog = false">Rögzítés új tanulóként</v-btn>
        <v-btn color="red" outlined @click="reserved_kat_dialog = false">mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="reserved_gki_dialog" persistent max-width="800">
    <v-card>
      <v-container>
        <b>Ilyen névvel már szerepel tanuló a rendszerben, kérjük válassza ki, hogy kit rendeljünk hozzá a fiókhoz?</b>
        <br>
        <v-data-table
          :headers="res_gki_headers"
          :items="reserved_gki_studs"
          :items-per-page="5"
          class="elevation-1"
          @click:row="etitanGKIUpdate($event)"
        ></v-data-table>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanGKIUploadNew(), reserved_gki_dialog = false">Rögzítés új tanulóként</v-btn>
        <v-btn color="red" outlined @click="reserved_gki_dialog = false">mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="reserved_kieg_dialog" persistent max-width="800">
    <v-card>
      <v-container>
        <b>Ilyen névvel már szerepel tanuló a rendszerben, kérjük válassza ki, hogy kit rendeljünk hozzá a fiókhoz?</b>
        <br>
        <v-data-table
          :headers="res_gki_headers"
          :items="reserved_gki_studs"
          :items-per-page="5"
          class="elevation-1"
          @click:row="etitanGKIUpdate($event)"
        ></v-data-table>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKiegUploadNew(), reserved_kieg_dialog = false">Rögzítés új tanulóként</v-btn>
        <v-btn color="red" outlined @click="reserved_kieg_dialog = false">mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

    <v-dialog v-model="plus_pot_dialog" persistent max-width="800">
    <v-card>
      <v-container>
        <p>{{response_text}}</p>
        <br>
        <p><b>Biztosan megrendeli a pótórát?</b></p>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanKatPotOrder9Plus(), plus_pot_dialog = false">Igen</v-btn>
        <v-btn color="red" outlined @click="plus_pot_dialog = false">mégsem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="username_dialog" persistent max-width="800">
    <v-card>
      <v-container>
        <v-data-table
          :headers="res_gki_headers"
          :items="reserved_gki_studs"
          :items-per-page="5"
          class="elevation-1"
        ></v-data-table>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="username_dialog = false">bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="etitan_stat_dialog" persistent max-width="900">
    <v-card>
      <v-container>
        <p><b>{{etitan_learningStatus}}</b></p>
        <p>{{etitan_haladasIdo}}</p>
        <v-simple-table>
        <thead>
          <tr>
            <th>Tanuló azonosító</th>
            <th>Tanulás kezdete</th>
            <th>Befejezés</th>
            <th>Tananyag elérhető</th>
            <th>9 hónap</th>
            <th>12 hónap</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in etitan_stat"
            :key="item.stud_id"
          >
            <td>{{ item.stud_id }}</td>
            <td>{{ item.LearningStartingDate }}</td>
            <td>{{ item.CourseCertificationDate }}</td>
            <td>{{ item.learningHatarido }}</td>
            <td>{{ item.ElsoElmeletiVizsgaHatarido }}</td>
            <td>{{ item.SikeresElmeletiVizsgaHatarido }}</td>
            <td><v-btn color="primary" :disabled="!item.stud_id" outlined @click="etitanSaveStat()">mentés</v-btn></td>
          </tr>
        </tbody>
        </v-simple-table>
        <br>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Tantárgyak
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="etitan_temakor_headers"
                :items="elearning_temakor"
                :items-per-page="10"
                hide-default-header
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Témakörök
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="etitan_haladas_headers"
                :items="elearning_haladas"
                :items-per-page="10"
                hide-default-header
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="etitan_stat_dialog = false">bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="etitan_vf_stat_dialog" persistent max-width="900">
    <v-card>
      <v-container>
        <p><b>{{etitan_learningStatus}}</b></p>
        <v-simple-table>
        <thead>
          <tr>
            <th>Tananyag elérhető</th>
            <th>Tanulással töltött idő</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in etitan_stat"
            :key="item.stud_id"
          >
            <td>{{ item.learningHatarido }}</td>
            <td>{{ item.learningHaladas }}</td>
          </tr>
        </tbody>
        </v-simple-table>
        <br>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Tantárgyak
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="etitan_temakor_headers"
                :items="elearning_temakor"
                :items-per-page="10"
                hide-default-header
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel>
            <v-expansion-panel-header>
              Témakörök
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table
                :headers="etitan_haladas_headers"
                :items="elearning_haladas"
                :items-per-page="10"
                hide-default-header
              ></v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="etitan_vf_stat_dialog = false">bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="etitan_penzugy_dialog" persistent max-width="900">
    <v-card>
      <v-container>
        <v-data-table
          :headers="etitan_befizetes_headers"
          :items="etitan_befizetesek"
          :items-per-page="5"
        ></v-data-table>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red" outlined @click="etitan_penzugy_dialog = false">bezár</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_close_confirm" persistent max-width="450">
    <v-card>
        <v-container>
        <b>Biztosan lezárja a képzést?</b>
        <br><br>
        <v-select
          v-model="titan_close_reason"
          :items="titan_close_reasons"
          label="Lezárás oka"
          outlined
          rounded
          dense
        ></v-select>
        </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="etitanClose(), titan_close_confirm = false" :disabled="!titan_close_reason">Igen</v-btn>
        <v-btn color="red" outlined @click="titan_close_confirm = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_mod_request_dialog" persistent max-width="1000">
    <v-card>
        <v-container>
        <b>Kérelemben szereplő adatok:</b>
        <br><br>
        <v-data-table
          v-model="selectedAdatKerelmek"
          :headers="adatmodositas_headers"
          :items="adatKerelmek"
          :items-per-page="5"
          class="elevation-1"
          item-key="Id"
          show-select
        >
        <template v-slot:header.data-table-select></template>
          <template v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox
                   :value="isSelected"
                   :disabled="item.Elbiralva"
                   @input="select($event)"
              ></v-simple-checkbox>
          </template>
          <template v-slot:item.Elbiralva="{ item }">
            <v-simple-checkbox
              v-model="item.Elbiralva"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.Jovahagyva="{ item }">
            <v-simple-checkbox
              v-model="item.Jovahagyva"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        </v-container>
      <v-card-actions>
        <v-btn color="red" outlined @click="titan_mod_request_dialog = false">Mégsem</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="selectedAdatKerelmek == ''" color="green" outlined @click="etitanModRequestAllow()">Jóváhagyás</v-btn>
        <v-btn :disabled="selectedAdatKerelmek == ''" color="red" outlined @click="etitanModRequestDeny()">Elutasítás</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="titan_address_request_dialog" persistent max-width="900">
    <v-card>
        <v-container>
        <b>Kérelemben szereplő adatok:</b>
        <br><br>
        <v-data-table
          v-model="selectedCimKerelmek"
          :headers="cimmodositas_headers"
          :items="cimKerelmek"
          :items-per-page="5"
          class="elevation-1"
          item-key="Id"
          show-select
        >
        <template v-slot:header.data-table-select></template>
          <template v-slot:item.data-table-select="{ item, isSelected, select }">
              <v-simple-checkbox
                   :value="isSelected"
                   :disabled="item.Elbiralva"
                   @input="select($event)"
              ></v-simple-checkbox>
          </template>
          <template v-slot:item.Elbiralva="{ item }">
            <v-simple-checkbox
              v-model="item.Elbiralva"
              disabled
            ></v-simple-checkbox>
          </template>
          <template v-slot:item.Jovahagyva="{ item }">
            <v-simple-checkbox
              v-model="item.Jovahagyva"
              disabled
            ></v-simple-checkbox>
          </template>
        </v-data-table>
        </v-container>
      <v-card-actions>
        <v-btn color="red" outlined @click="titan_address_request_dialog = false">Mégsem</v-btn>
        <v-spacer></v-spacer>
        <v-btn :disabled="selectedCimKerelmek == ''" color="green" outlined @click="etitanAddressRequestAllow()">Jóváhagyás</v-btn>
        <v-btn :disabled="selectedCimKerelmek == ''" color="red" outlined @click="etitanAddressRequestDeny(), titan_address_request_dialog = false">Elutasítás</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="del_course_dialog" persistent max-width="330">
    <v-card>
      <v-card-text class="pt-4">Biztosan eltávolítja a tanulót a tanfolyamról?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="delStudentCourse(), del_course_dialog = false">Igen</v-btn>
        <v-btn color="primary" text @click="del_course_dialog = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="preg_dialog" persistent max-width="450">
    <v-card>
      <v-container>
      <b>Biztosan előregisztrálja a tanulót?</b>
      <br><br>
      <v-select
        v-model="sel_vd"
        :items="vd_payments"
        label="Vizsgadíj hozzárendelése"
        item-value="payment_id"
        outlined
        rounded
        dense
      >
        <template v-slot:selection="data">
          <!-- HTML that describe how select should render selected items -->
          {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
        </template>
        <template v-slot:item="data">
          <!-- HTML that describe how select should render items when the select is open -->
          {{ data.item.amount }} - {{ data.item.invoice_date }} ({{data.item.invoice_number}})
        </template>
      </v-select>
      <v-checkbox
        v-if="admin"
        v-model="free_exam"
        label="Díjmentesség"
      ></v-checkbox>
      </v-container>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="green" outlined @click="preg_dialog = false, examPrereg()" :disabled="!sel_vd && !free_exam">Igen</v-btn>
        <v-btn color="red" outlined @click="preg_dialog = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="preg_del_dialog" persistent max-width="290">
    <v-card>
      <v-card-text class="pt-4">Biztosan törli az előjegyzést?</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="examPreregDel(), preg_del_dialog = false">Igen</v-btn>
        <v-btn color="primary" text @click="preg_del_dialog = false">Nem</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog v-model="kepzesi_dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="green lighten-1">
          <v-toolbar-title>KAV képzési adatok</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon dark @click="kepzesi_dialog = false, kokenyUgyId = null, Athelyezett = '', VanKepzesiIgazolas = '', atvetel_preview = '', tanulo_atvetel = false, kulsos_azonosito = '', vonalkod = '', kateg_mod = false, changed_kateg = ''">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-progress-linear :active="kepzesi_preloader" :indeterminate="kepzesi_preloader" absolute color="teal"></v-progress-linear>
        <v-container>
        <v-card>
        <v-card-title>
          Tanuló kiválasztása
        </v-card-title>
        <v-data-table
          :headers="kav_tanulok_headers"
          :items="kav_tanulok"
          :items-per-page="5"
          class="elevation-1"
          @click:row="kepzesiAdatok($event.UgyId, $event.Athelyezett, $event.VanKepzesiIgazolas, $event.StudIdProblem)"
        ></v-data-table>
        </v-card>
        <v-row v-if="admin && !kokenyUgyId">
          <v-col cols="12" md="3" v-if="!kepzesi_preloader && !kateg_mod">
          <v-btn
          color="red"
          outlined
          @click="getCategoryList()"
        >
          Kategória módosítás
          <v-icon right dark>change_circle</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="kateg_mod">
          <v-select
          v-model="changed_kateg"
          :items="category_list"
          item-text="contract_name"
          return-object
          label="Kategória választása"
          outlined
          ></v-select>
        </v-col>
        <v-col cols="12" md="4" v-if="kateg_mod" class="mt-2">
          <v-btn
            color="green"
            outlined
            :disabled="!changed_kateg"
            @click="change_kateg_confirm = true"
            >
            Rögzítés
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-col>

        <v-dialog
        v-model="change_kateg_confirm"
        width="500"
        >
          <v-card>

            <v-card-text class="subtitle-1">
            <v-container>
              Biztosan elvégzi a kategória váltást?
            </v-container>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="red"
                text
                @click="change_kateg_confirm = false"
              >
                Mégsem
              </v-btn>
              <v-btn
                color="green"
                text
                @click="changeCategory()"
              >
                Rögzítés
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        </v-row>
         <v-row>
          <v-col cols="12" md="3" v-if="!kepzesi_preloader && !tanulo_atvetel && !kokenyUgyId">
          <v-btn
          color="primary"
          outlined
          @click="tanulo_atvetel = true"
        >
          Tanuló átvétel
          <v-icon right dark>download</v-icon>
        </v-btn>
        </v-col>
        <v-col cols="12" md="4" v-if="tanulo_atvetel">
          <v-text-field
            v-model="kulsos_azonosito"
            label="Tanuló azonosító"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="4" v-if="tanulo_atvetel">
          <v-text-field
            v-model="vonalkod"
            label="Képzési igazolás vonalkód"
            outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" v-if="tanulo_atvetel" class="mt-2">
          <v-btn
            color="primary"
            outlined
            @click="atvetelCheck()"
            :disabled="!kulsos_azonosito || !vonalkod"
            >
            Keresés
            <v-icon right dark>search</v-icon>
          </v-btn>
        </v-col>
        <v-col cols="12" md="2" v-if="tanulo_atvetel" class="mt-2">
          <v-btn
            color="green"
            outlined
            :disabled="!kulsos_azonosito || !vonalkod"
            @click="oktatasPayments(), befogado_dialog = true"
            >
            Befogadó
          </v-btn>
        </v-col>
        <div v-if="atvetel_preview" v-html="atvetel_preview"></div>
        <v-col cols="12" md="4" v-if="atvetel_preview" class="mt-2">
          <v-btn
            color="primary"
            outlined
            @click="oktatasPayments(), atvetel_dialog = true"
            >
            Tanuló átvétel
            <v-icon right dark>save</v-icon>
          </v-btn>
        </v-col>

        <v-dialog v-model="atvetel_dialog" persistent max-width="450">
          <v-card>
              <v-container>
              <b>Biztosan átveszi a tanulót?</b>
              <br><br>
              <v-select
                v-model="sel_payment"
                :items="titan_payments"
                label="Befizetés hozzárendelése"
                item-value="payment_id"
                outlined
                rounded
                multiple
              >
              <template v-slot:selection="{ item, index }">
                <v-chip>
                  <span>{{ item.amount }} - {{ item.invoice_date }}</span>
                </v-chip>
              </template>

              <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              </v-select>
              <v-checkbox
                v-if="admin"
                v-model="free_learning"
                label="Tandíjmentesség"
              ></v-checkbox>
              </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" outlined @click="atvetelSave(), atvetel_dialog = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && (course_type_to_select != 87 && course_type_to_select != 88 && course_type_to_select != 89 && course_type_to_select != 90 && course_type_to_select != 91)">Igen</v-btn>
              <v-btn color="red" outlined @click="atvetel_dialog = false">Nem</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-dialog v-model="befogado_dialog" persistent max-width="450">
          <v-card>
              <v-container>
              <b>Biztosan kiállítja a befogadó nyilatkozatot?</b>
              <br><br>
              <v-select
                v-model="sel_payment"
                :items="titan_payments"
                label="Befizetés hozzárendelése"
                item-value="payment_id"
                outlined
                rounded
                multiple
              >
              <template v-slot:selection="{ item, index }">
                <v-chip>
                  <span>{{ item.amount }} - {{ item.invoice_date }}</span>
                </v-chip>
              </template>

              <template v-slot:item="{ active, item, attrs, on }">
                <v-list-item v-on="on" v-bind="attrs" #default="{ active }">
                  <v-list-item-action>
                  <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.amount }} - {{ item.invoice_date }} ({{item.invoice_number}})
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </template>

              </v-select>
              <v-checkbox
                v-if="admin"
                v-model="free_learning"
                label="Tandíjmentesség"
              ></v-checkbox>
              </v-container>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" outlined @click="saveBefogado(), befogado_dialog = false" :disabled="(!sel_payment || sel_payment == '') && !free_learning && (course_type_to_select != 87 && course_type_to_select != 88 && course_type_to_select != 89 && course_type_to_select != 90 && course_type_to_select != 91)">Igen</v-btn>
              <v-btn color="red" outlined @click="befogado_dialog = false">Nem</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        </v-row>
        <div v-if="Athelyezett == true && !VanKepzesiIgazolas" class="text-center">
          <br>
          Az áthelyezett tanuló képzésének részletei nem érhetők el a KAV rendszerében.
        </div>
        <div v-if="kokenyUgyId && Athelyezett == false || (Athelyezett == true && VanKepzesiIgazolas == true)">
        <br>
        <v-card>
        <v-card-title>
          Képzési adatok
        </v-card-title>
        <v-card-text>
        <v-row>
          <v-col cols="12" md="6">
            <b>Kategória:</b> {{Kategoria}}
          </v-col>
          <v-col cols="12" md="6">
            <b>Tanuló azonosító:</b> {{azonosito}}
          </v-col>
          <v-col cols="12" md="6">
            <b>Tanfolyam típusa:</b> {{TanfolyamTipusString}}
          </v-col>
          <v-col cols="12" md="6">
            <b>Tanfolyam kezdete:</b> {{TanfolyamKezdete}}
          </v-col>
          <v-col cols="12" md="6">
            <b>Ügy érvényessége:</b> {{UgyErvenyesseg}}
          </v-col>
        </v-row>
        <v-row v-if="StudIdProblem">
          <v-col cols="12" md="6" class="red--text">
          A tanuló azonosítója eltér a KAV rendszerében rögzítettől!
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="red" outlined @click="modStudId()">Azonosító frissítése</v-btn>
          </v-col>
        </v-row>
        </v-card-text>
        </v-card>
        <br>
        <v-card>
        <v-card-title>
          Képzési eredmények
        </v-card-title>
        <v-card-text v-if="Athelyezett">
        <v-row>
          <v-col cols="12">
            <b>Első KRESZ elméleti vizsga időpontja:</b> {{ElsoKozlIsmElmeletVizsgaIdeje}}
          </v-col>
          <v-col cols="12">
            <b>Sikeres KRESZ vizsga időpontja:</b> {{SikeresKozlIsmElmeletVizsgaIdeje}}
          </v-col>
        </v-row>
        </v-card-text>
        <v-data-table
          v-if="!Athelyezett"
          :headers="kepzesi_eredmenyek_headers"
          :items="kepzesi_eredmenyek"
          :items-per-page="10"
          class="elevation-1"
        ></v-data-table>
        </v-card>
        <br>
        <v-card>
        <v-card-title>
          Vezetési órák összesítése
        </v-card-title>
        <v-data-table
          :headers="gyakorlat_headers"
          :items="gyakorlat"
          :items-per-page="10"
          class="elevation-1"
        ></v-data-table>
        </v-card>
        
        <br>
        <v-card>
        <v-card-title>
          Képzési igazolás
        </v-card-title>
        <div class="text-center" v-if="!kepzesi_preloader && (!isArchived || ConractStatus != 'Elment') && (ConractStatus != 'Áthelyezés alatt - Szigetszentmiklós' && ConractStatus != 'Áthelyezés alatt - Petzvál')">
          <br>
          A képzési igazolás kiállítása előtt kérjük archiválja a tanulót és a szerződés státuszát állítsa "Elment"-re vagy állítson be "Áthelyezés alatti" státuszt, attól függően, hogy mi a képzési igazolás kiállításának oka!
        </div>
        <v-container v-if="(isArchived && ConractStatus == 'Elment') || ConractStatus == 'Áthelyezés alatt - Szigetszentmiklós' || ConractStatus == 'Áthelyezés alatt - Petzvál'">
         <div>
          {{kepzesi_results}}
          </div>
          <v-row>
          <v-col cols="12" md="3" v-if="kepzesiStatus">
          <v-btn
          color="primary"
          rounded
          @click="kepzesi_save_dialog = true"
          :loading="saveKepzesiLoad"
          :disabled="kepzesi_preloader"
        >
          Képzési kiadás
          <v-icon right dark>save</v-icon>
        </v-btn>
        </v-col>
      <v-col cols="12" md="" v-if="kepzesi_reload">
        <v-btn
          color="primary"
          rounded
          @click="downloadKepzesiKokeny"
          :loading="dots_loading"
          :disabled="kepzesi_preloader || kepzesiStatus"
        >
          nyomtatás
          <v-icon right dark>print</v-icon>
        </v-btn>
         </v-col>
       </v-row>
         <v-row v-if="kepzesi_reload">
          <v-col cols="12" md="5">
            <v-text-field
              v-model="email_name"
              outlined
              label="Címzett"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="5">
            <v-text-field
              v-model="email"
              outlined
              label="E-mail cím"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="mt-2">
          <v-btn :loading="kepzesi_send" :disabled="kepzesi_send || !email_name || !email" @click="kepzesiSend()" rounded color="primary">Küldés</v-btn>
          </v-col>
        </v-row>
        </v-container>
      </v-card>
      </div>
      </v-container>
      </v-card>
    </v-dialog>

      <v-dialog v-model="kepzesi_save_dialog" persistent max-width="450">
        <v-card>
          <br>
            <v-container>
              Biztosan kiállítja a képzési igazolást? Ezzel a tanuló áthelyezésre kerül. A művelet nem visszafordítható!
            </v-container>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="kepzesi_save_dialog = false">Nem</v-btn>
            <v-btn color="green" outlined @click="kepzesiKiad(), kepzesi_save_dialog = false">Igen</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="contract_upload_dialog" persistent max-width="450">
        <v-card>
          <br>
            <v-container>
              <div>
                <v-file-input
                  v-model="contract_to_upload"
                  outlined
                  small-chips
                  label="Fájlok kiválasztása"
                ></v-file-input>
              </div>
            </v-container>
          <v-card-actions>
            <v-btn color="primary" outlined v-if="contract_url" @click="downloadUploadedContract()" :loading="downloading">szerződés letöltése</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="red" outlined @click="contract_upload_dialog = false">Mégsem</v-btn>
            <v-btn color="green" outlined @click="contractUpload()" :disabled="!contract_to_upload" :loading="uploading">Feltölt</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

  </div>
</template>

<script>
import store from '../store'
import DiakJellap from '../components/diakok_jellap.vue'

import {
  mapFields
} from 'vuex-map-fields'

  export default {
    components: {
      DiakJellap
    },
    data () {
      return {
        //student_course_details: '',
        loading: false,
        dots_loading: false,
        school_id: '',
        jellap_show: false,
        add_course_dialog: false,
        add_course_header: [
          { text: 'Tanfolyam száma', value: 'course_number'},
          { text: 'Kezdés', value: 'course_start' },
          { text: 'Befejezés', value: 'course_end' },
          { text: 'Tanfolyam típus', value: 'course_type' },
          { text: 'Helyszín', value: 'place_name' },
          { text: 'Létszám', value: 'count' },
          { text: 'Hozzáad'},
        ],
        courses_to_add: '',
        tanfolyam_search_text: '',
        selected_course: '',
        course_add_button: false,
        response_text: '',
        nevsor_response_text: '',
        response_snackbar: false,
        snackbar_color: '',
        snackbar_close: 'pink',
        course_del_id: '',
        courses_data_del_id: '',
        kepzesi_course_id: '',
        del_course_dialog: false,
        roster_status: '',
        course_data_change: false,
        kepzesi_dialog: false,
        karton: '-',
        failed_exams: '-',
        restrictions: '-',
        bu: false,
        dp_a: '-',
        dp_fv: '-',
        dp_fo: '-',
        dp_fh: '-',
        dp_fe: '-',
        dp_fk: '-',
        preg_course_data_id: '',
        preg_course_student_id: '',
        preg_driving_school_id: '',
        preg_dialog: false,
        course_start: '',
        course_end: '',
        first_exam: '',
        successful_exam: '',
        kepzesi_preloader: false,
        preg_del_dialog: false,
        preg_del_id: '',
        exam_place_code: '',
        gki_show: false,
        kartya_kiallitas: [
          { text: 'Igen', value: '1'},
          { text: 'Nem', value: '2' },
          { text: 'Összevonást kér', value: '4' },
        ],
        kartya_atvetel: [
          { text: 'GKI igazolványomat postai úton kérem kézbesíteni hivatalos iratként az értesítési címemre.', value: '1'},
          { text: 'GKI igazolványomat személyesen veszem át a KAV KVI Szaktanfolyami Főosztályán', value: '14' },
        ],
        kartyaRules: [
            v => !!v || 'Kötelező mező!',
        ],
        kartya_kiallitas_value: '',
        kartya_atvetel_value: '',
        valid: true,
        pallasz_id: '',
        response_success: '',
        gki_snackbar: false,
        etitan_dialog: false,
        titanKatLoading: false,
        titan_order_confirm: false,
        titan_katpot_order_confirm: false,
        gki_order_confirm: false,
        selected_training_type: '',
        kieg_tanfolyamok: [
          { text: 'Vizsgafelkészítő - 12 óra', value: 'VF12'},
          { text: 'Vizsgafelkészítő - 24 óra', value: 'VF24'},
          { text: 'Elsősegély', value: 'EU' },
        ],
        sel_kieg_tanfolyam: '',
        titan_kieg_order_confirm: false,
        vizsgafelk_items: [
          { text: 'Vizsgafelkészítő - 12 óra', value: 'VF12'},
          { text: 'Vizsgafelkészítő - 24 óra', value: 'VF24'},
          { text: 'Oktatóanyag és vizsgafelkészítő', value: 'OKT'},
        ],
        selected_vizsgafelk: '',
        vizsgafelk_order_confirm: false,
        nyelv_items: [
          { text: 'Magyar', value: 0},
          { text: 'Angol', value: 1},
          { text: 'Német', value: 2},
        ],
        nyelv: 0,
        titan_payments: [],
        sel_payment: '',
        titan_loading: 0,
        titan_loading_bar: false,
        interval: 0,
        reserved_gki_studs: [],
        reserved_gki_dialog: false,
        res_gki_headers: [
          { text: 'Tanuló', value: 'tanulo' }
        ],
        titan_gkipot_order_confirm: false,
        reserved_kieg_dialog: false,
        vizsgafelk_pot_order_confirm: false,
        kieg_pot_order_confirm: false,
        etitan_stat_dialog: false,
        etitan_vf_stat_dialog: false,
        etitan_stat: [],
        etitan_haladasIdo: '',
        etitan_learningStatus: '',
        etitan_haladas_headers: [
          { text: 'E-learning haladás', value: 'targy'},
          { text: 'Teljesítés', value: 'teljesites'},
        ],
        etitan_temakor_headers: [
          { text: 'Témakör', value: 'temakor'},
        ],
        reserved_kat_dialog: false,
        titan_course_data_id: '',
        titan_course_id: '',
        elearning_haladas: [],
        elearning_temakor: [],
        etitan_befizetesek: [],
        etitan_penzugy_dialog: false,
        etitan_befizetes_headers: [
          { text: 'Befizetések', value: 'befizetes'},
          { text: 'Kiírás dátuma', value: 'datum'},
        ],
        titan_close_reasons: [
          { text: 'Téves beíratás', value: "0"},
          { text: 'Nem kezdte meg a képzését', value: "1"},
          { text: 'Elméleti határidőből kifutott', value: "2"},
          { text: 'Gyakorlati határidőből kifutott', value: "3"},
          { text: 'Egyéb', value: "4"},
        ],
        titan_close_reason: '',
        titan_close_confirm: false,
        titan_postorder_confirm: false,
        gki_karton_az: '',
        gki_karton_date: '',
        titan_data_mod: '',
        titan_data_mod_types: [
          { text: 'E-mail cím módosítás', value: 1},
          { text: 'Személyes adat módosítás', value: 2},
          { text: 'E-mail újraküldés', value: 3},
          { text: 'Adatmódosítási kérelem', value: 4},
          { text: 'Címmódosítási kérelem', value: 5}
        ],
        pallasz_dialog: false,
        titan_mod_request_dialog: false,
        titan_address_request_dialog: false,
        mod_text: [],
        all_requests: '',
        free_learning: false,
        sel_vd: '',
        vd_payments: [],
        free_exam: false,
        username_dialog: false,
        euVf: false,
        isArchived: '',
        ConractStatus: '',
        contract_to_upload: [],
        contract_upload_dialog: false,
        contract_url: '',
        downloading: false,
        uploading: false,
        plus_pot_dialog: false,
        add_to_course_confirm: false,
        course_id_to_add: '',
        course_number_to_add: '',
        course_type_to_select: '',
        course_data_id_to_add: '',
        roster_status_to_add: '',
        finalize_to_course_confirm: false,
        prereg: false,
        kepzesiStudDetails: '',
        kepzesi_results: '',
        kepzesi_error: '',
        kokenyUgyId: '',
        saveKepzesiLoad: false,
        kepzesiStatus: false,
        kepzesi_save_dialog: false,
        send_preloader: false,
        pallasz_id_status: '',
        kokeny_id: '',
        kav_tanulok: [],
        kav_tanulok_headers: [
          { text: 'Tanuló neve', value: 'Teljesnev'},
          { text: 'Születési idő', value: 'SzuletesiIdo'},
          { text: 'Anyja neve', value: 'AnyjaNeve'},
          { text: 'Tanuló azonosító', value: 'TanuloAzonosito'},
          { text: 'Kategória', value: 'KepzesNeve'},
        ],
        kepzesi_eredmenyek: [],
        kepzesi_eredmenyek_headers: [
          { text: 'Vizsga típus', value: '0'},
          { text: 'Vizsga kód', value: '1'},
          { text: 'Állapot', value: '2'},
          { text: 'Utolsó eredmény', value: '3'},
        ],
        gyakorlat: [],
        gyakorlat_headers: [
          { text: 'Vezetés típusa', value: '0'},
          { text: 'Előírt óraszám', value: '1'},
          { text: 'Előírt óraszám percekben', value: '2'},
          { text: 'Vezetett perc', value: '3'},
          { text: 'Vezetett km', value: '4'},
        ],
        cimmodositas_headers: [
          { text: 'Cím', value: 'Cim'},
          { text: 'Típus', value: 'Tipus'},
          { text: 'Elbírálva', value: 'Elbiralva'},
          { text: 'Jóváhagyva', value: 'Jovahagyva'},
        ],
        adatmodositas_headers: [
          { text: 'Név', value: 'TeljesNev'},
          { text: 'Születési név', value: 'SzuletesiNev'},
          { text: 'Állampolgárság', value: 'Allampolgarsag'},
          { text: 'Anyja neve', value: 'AnyjaNeve'},
          { text: 'Születési hely', value: 'SzuletesiHely'},
          { text: 'Elbírálva', value: 'Elbiralva'},
          { text: 'Jóváhagyva', value: 'Jovahagyva'},
        ],
        azonosito: '',
        UgyErvenyesseg: '',
        TanfolyamTipusString: '',
        TanfolyamKezdete: '',
        Kategoria: '',
        UgyId: '',
        Athelyezett: '',
        VanKepzesiIgazolas: '',
        adatszolg_dialog: false,
        kepzesi_reload: '',
        SikeresKozlIsmElmeletVizsgaIdeje: '',
        ElsoKozlIsmElmeletVizsgaIdeje: '',
        StudIdProblem: '',
        course_data_id_toChange: '',
        kepzesi_send: false,
        email: '',
        email_name: '',
        tanulo_atvetel: false,
        kulsos_azonosito: '',
        vonalkod: '',
        atvetel_preview: '',
        kepzesi_id: '',
        kepzesi_token: '',
        atvetel_dialog: false,
        kateg_mod: false,
        changed_kateg: '',
        category_list: [],
        change_kateg_confirm: false,
        course_id_toChange: '',
        tanultIdo: '',
        gki_vn_datas: [],
        gki_kartya_datas: [],
        gki_vn_loading: false,
        vn_dialog: false,
        gki_kartya_loading: false,
        kartya_dialog: false,
        cimKerelmek: [],
        selectedCimKerelmek: [],
        adatKerelmek: [],
        selectedAdatKerelmek: [],
        befogado_dialog: false,
        befogado_stream: '',
        befogado_print_dialog: false
      }
    },
    methods: {
      jellapDetails (course_id, course_student_id, course_data_id, training_type) {
        this.course_id = course_id
        this.jellap_show = true
        this.course_student_id = course_student_id
        this.course_data_id = course_data_id
        this.training_type = training_type
      },
      atvetelCheck: async function() {
        this.atvetel_preview = '';
        await this.gettoken()
        this.$http.post('/kokeny/atvetel_check', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          kulsos_azonosito: this.kulsos_azonosito,
          vonalkod: this.vonalkod
        }).then((response) => {
          this.atvetel_preview = response.data['html'];
          this.kepzesi_id = response.data['kepzesi_id'];
          this.kepzesi_token = response.data['token'];
        }, (error) => {
          this.error_text = error.data
        })
      },
      atvetelSave: async function() {
        await this.gettoken()
        this.$http.post('/kokeny/atvetel_save', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          kepzesi_id: this.kepzesi_id,
          kepzesi_token: this.kepzesi_token,
          kulsos_azonosito: this.kulsos_azonosito,
          course_data_id: this.course_data_id_toChange,
          payment: this.sel_payment,
          free_learning: this.free_learning
        }).then((response) => {
          this.response_text = response.data['message'];
          if (response.data['success'] == true) {
            this.tanulo_atvetel = false;
            this.atvetel_preview = '';
            this.getCourseDetails()
            this.kepzesi_dialog = false;
          }
          this.gki_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      gkiJellapDetails: async function() {
        this.preloader = true
        this.gki_show = true
        await this.gettoken()
        this.$http.post('/diakok/gki_jellap_details', {
          token: this.token,
          course_data_id: this.course_data_id
        }).then((response) => {
          this.preloader = false
          this.kartya_kiallitas_value = response.data[0]['gki_kartya_igeny']
          this.kartya_atvetel_value = response.data[0]['gki_kartya_atvetel']
          this.pallasz_id = response.data[0]['pallasz_id']
          this.gki_karton_az = response.data[0]['gki_karton_az']
          this.gki_karton_date = response.data[0]['gki_karton_date']
          this.pallasz_id_status = response.data[0]['reg_form_status']
          this.validate()
        }, (error) => {
          console.log(error.data);
        })
      },
      saveGkiJellapDetails: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/save_gki_jellap_details', {
          token: this.token,
          course_data_id: this.course_data_id,
          kartya_kiallitas_value: this.kartya_kiallitas_value,
          kartya_atvetel_value: this.kartya_atvetel_value
        }).then((response) => {
          this.preloader = false
          this.gkiJellapDetails()
          this.response_snackbar = true
          this.response_text = response.data;
          if (this.pallasz_id) {
            //this.pallasz_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      GKIJellapUpload: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_upload_gki', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.pallasz_id = response.data['id'];
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      GKIJellapMod: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_mod_gki', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      bekuldJellap: async function() {
        this.adatszolg_dialog = false;
        this.preloader = true;
        this.send_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_bekuld_gki', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          this.gkiJellapDetails()
          this.preloader = false
          this.send_preloader = false;
          this.response_text = response.data['message'];
          this.gki_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      bekuldStatusz: async function() {
        if (confirm("Biztosan elvégzi a műveletet?") == true) {
        this.adatszolg_dialog = false;
        store.state.showing.preloader = true
        this.send_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/adatlap_bekuld_statusz_gki', {
          token: this.token,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.gkiJellapDetails()
          store.state.showing.preloader = false
          this.send_preloader = false;
          this.response_text = response.data['message'];
          this.gki_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
        }
      },
      saveTanf: async function() {
        if (confirm("Biztosan elvégzi a műveletet?") == true) {
        this.adatszolg_dialog = false;
        this.preloader = true;
        this.send_preloader = true;
        await this.gettoken()
        this.$http.post('/kokeny/tanfolyam_save_gki', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          course_student_id: this.course_student_id,
          pallasz_id: this.pallasz_id,
          course_data_id: this.course_data_id
        }).then((response) => {
          this.gkiJellapDetails()
          this.preloader = false
          this.send_preloader = false;
          this.response_text = response.data['message'];
          this.gki_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      }
      },
      checkAdatlapIktat: async function() {
        this.gki_vn_datas = []
        this.gki_kartya_datas = []
        this.send_preloader = true
        await this.gettoken()
        this.$http.post('/diakok/jellap_status_gki', {
          token: this.token,
          customer_id: this.customer_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
        }).then((response) => {
          this.send_preloader = false
          this.response_text = response.data['success'];
          this.gki_vn_datas = response.data['vizsgamentes'];
          this.gki_kartya_datas = response.data['kartya'];
          this.gki_snackbar = true;
        }, (error) => {
          this.send_preloader = false
          console.log(error.data);
        })
      },
      gkiVnIgazolas: async function() {
        this.gki_vn_loading = true;
        await this.gettoken()
        this.$http.post('/diakok/gki_vn_igazolas', {
          token: this.token,
          gki_vn_datas: this.gki_vn_datas
        }).then((response) => {
          this.gki_vn_loading = false;
          this.vn_dialog = false;
          this.response_text = response.data;
          this.gki_snackbar = true;
          this.checkAdatlapIktat()
        }, (error) => {
          this.gki_vn_loading = false;
          console.log(error.data);
        })
      },
      gkiKartyaBefiz: async function() {
        this.gki_kartya_loading = true;
        await this.gettoken()
        this.$http.post('/diakok/gki_kartya_befizetes', {
          token: this.token,
          gki_kartya_datas: this.gki_kartya_datas
        }).then((response) => {
          this.gki_kartya_loading = false;
          this.kartya_dialog = false;
          this.response_text = response.data;
          this.gki_snackbar = true;
          this.checkAdatlapIktat()
        }, (error) => {
          this.gki_kartya_loading = false;
          console.log(error.data);
        })
      },
      GKISzemelyesUpdate: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/gki_jellap_update_personal', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      GKIJogsiUpdate: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/gki_jellap_update_docs', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      GkiTanfUpdate: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/gki_jellap_update_tanf', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      GKIJellapDownload: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/gki_jellap_print', {
          token: this.token,
          course_data_id: this.course_data_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      GkiKartonAz: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/pallasz/gki_karton_az', {
          token: this.token,
          course_data_id: this.course_data_id,
          course_id: this.course_id,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          pallasz_id: this.pallasz_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.gki_karton_az = response.data['id'];
          this.gkiJellapDetails()
        }, (error) => {
          console.log(error.data);
        })
      },
      getCourseDetails: async function() {
        this.course_data_change = false
        this.loading = true
        this.course_id = null
        this.jellap_show = false
        this.course_student_id = null
        await this.gettoken()
        this.$http.post('/diakok/tanfolyam_adatok', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
        }).then((response) => {
          this.preloader = false
          this.loading = false
          this.student_course_details = response.data
          this.school_id = response.data[0]['driving_school_id']
          this.course_student_id = response.data[0]['course_student_id']
        }, (error) => {
          console.log(error.data);
        })
      },
      getXML: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/etitan/registration', {
          token: this.token,
          contract_id: this.contract_id,
        }).then((response) => {
          this.loading = false
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', this.full_name+'.xml') //or any other extension
          document.body.appendChild(link)
          link.click()

        }, (error) => {
          console.log(error.data);
        })
      },
      openEtitan () {
        if (this.school_id == 1) {
          window.open('https://etitan.hu/site/4333f2ea-5e53-4b44-b46b-12e24bf35a8e/Alkalmazott/TanulokByIskola/NKHXMLFeltoltes')
        } else if (this.school_id == 2) {
          window.open('https://etitan.hu/site/7e64fcf5-8b01-43b5-8c3e-2f1bddc2ae5f/Alkalmazott/TanulokByIskola/NKHXMLFeltoltes')
        }
      },
      searchCourses: async function() {
        this.courses_to_add = ''
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/tanfolyamok_search', {
          token: this.token,
          nkh_course_type_id: this.nkh_course_type_id,
          tanfolyam_search_text: this.tanfolyam_search_text
        }).then((response) => {
          this.preloader = false
          this.courses_to_add = response.data

        }, (error) => {
          this.error_text = error.data
        })
      },
      addStudentCourse: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_diakok_check', {
          token: this.token,
          course_id: this.course_id_to_add,
        }).then((response) => {

          if (response.data['result'] == 'error') {
            alert("A meghirdetett helyek száma betelt!")
          }

            this.$http.post('/diakok/tanfolyam_add_student_20230717', {
              token: this.token,
              course_id: this.course_id_to_add,
              customer_id: this.customer_id,
              contract_id: this.contract_id,
              course_number: this.course_number_to_add,
              payment: this.sel_payment,
              free_learning: this.free_learning,
              prereg: this.prereg,
              course_type_key: this.nkh_course_type_id
            }).then((response) => {
              this.preloader = false
              this.response_text = response.data['message']
              this.roster_status = response.data['roster']
              if (response.data['result'] == 'error') {
                this.snackbar_color = 'error'
                this.snackbar_close = ''
              } else {
                this.snackbar_color = null
                this.snackbar_close = 'pink'
              }
              this.lessonHeadcountAdd()
              this.getCourseDetails();
              if (this.roster_status == 'Uploaded' || this.roster_status == null) {
                this.nevsorUploadAdd()
              }
              this.add_course_dialog = false
              this.response_snackbar = true
            }, (error) => {
              this.error_text = error.data
            })

           this.preloader = false
        }, (error) => {
          this.error_text = error.data
        })

      },
      delStudentCourse: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/tanfolyam_del_student_20210805', {
          token: this.token,
          course_id: this.course_del_id,
          courses_data_id: this.courses_data_del_id,
          customer_id: this.customer_id,
          contract_id: this.contract_id
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          this.roster_status = response.data['roster']
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.lessonHeadcountDel()
          this.getCourseDetails();
          if (this.roster_status == 'Uploaded') {
            this.nevsorUploadDel()
          }
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      pregStudents: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/tanfolyam_preg_student_20221103', {
          token: this.token,
          course_data_id: this.course_data_id_to_add,
          course_id: this.course_id_to_add,
          course_number: this.course_number_to_add,
          payment: this.sel_payment,
          status: 'Pending',
          course_type_key: this.nkh_course_type_id,
          free_learning: this.free_learning
        }).then((response) => {
          store.state.showing.preloader = false
          this.response_text = response.data['message']
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.getCourseDetails()
          this.lessonHeadcountAdd()
          if (this.roster_status_to_add == 'Uploaded') {
            this.nevsorUploadAdd()
          }
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
      },
      examPrereg: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/exam_prereg_20210720', {
          token: this.token,
          course_data_id: this.preg_course_data_id,
          course_student_id: this.preg_course_student_id,
          driving_school_id: this.preg_driving_school_id,
          customer_id: this.customer_id,
          contract_id: this.contract_id,
          vd_payment: this.sel_vd
        }).then((response) => {
          this.preloader = false
          if (response.data['result'] == 'error') {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.response_text = response.data['message']
          this.response_snackbar = true
          this.getCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      examPreregDel: async function() {
        store.state.showing.preloader = true
        await this.gettoken()
        this.$http.post('/vizsgak/del_prereg_student_20210720', {
          token: this.token,
          eab_id: this.preg_del_id
        }).then((response) => {
          this.snackbar_color = null
          this.snackbar_close = 'pink'
          this.response_text = response.data
          this.response_snackbar = true
          store.state.showing.preloader = false
          this.getCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      modCourseDetails: async function(course_id, course_data_id, course_number, course_student_id, start_date, end_date) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/tanfolyam_details_mod', {
          token: this.token,
          course_id: course_id,
          course_data_id: course_data_id,
          course_number: course_number,
          course_student_id: course_student_id,
          start_date: start_date,
          end_date: end_date
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data
          this.response_snackbar = true
          this.getCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      modStudId: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/stud_id_change', {
          token: this.token,
          course_data_id: this.course_data_id_toChange,
          course_student_id: this.azonosito,
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data
          this.response_snackbar = true
          this.getCourseDetails()
        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcountDel: async function() {
        this.headcount_update = false
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_headcount', {
          token: this.token,
          course_del_id: this.course_del_id,
        }).then((response) => {
          this.headcount_update = response.data
          this.preloader = false
          this.course_del_id = null

        }, (error) => {
          this.error_text = error.data
        })
      },
      lessonHeadcountAdd: async function() {
        this.headcount_update = false
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/lessons_headcount', {
          token: this.token,
          course_id_selected: this.selected_course,
        }).then((response) => {
          this.headcount_update = response.data
          this.preloader = false
          this.selected_course = null

        }, (error) => {
          this.error_text = error.data
        })
      },
      nevsorUploadDel: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/nevsor_upload', {
          token: this.token,
          del_course_id: this.course_del_id,
        }).then((response) => {
          this.preloader = false
          this.nevsor_response_text = response.data['result']

        }, (error) => {
          this.error_text = error.data
        })
      },
      nevsorUploadAdd: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/tanfolyamok/nevsor_upload', {
          token: this.token,
          selected_course_id: this.selected_course,
        }).then((response) => {
          this.preloader = false
          this.nevsor_response_text = response.data['result']

        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadContract: async function(course_id) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/szerzodes_shared', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: course_id,
        }, {responseType: 'blob'}).then((response) => {
          this.preloader = false
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.full_name+'_szerzodes.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      signContract: async function(course_id) {
        if (confirm('Biztosan elküldi a szerződést aláírásra?')) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/szerzodes_alairas_20210726', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: course_id,
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          if (response.data['success'] == false) {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
       }
      },
      parentSign: async function(course_id) {
        if (confirm('Biztosan elküldi a szerződést aláírásra?')) {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/szuloi_alairas', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: course_id,
        }).then((response) => {
          this.preloader = false
          this.response_text = response.data['message']
          if (response.data['success'] == false) {
            this.snackbar_color = 'error'
            this.snackbar_close = ''
          } else {
            this.snackbar_color = null
            this.snackbar_close = 'pink'
          }
          this.response_snackbar = true
        }, (error) => {
          this.error_text = error.data
        })
       }
      },
      kepzesiPreview: async function() {
        this.course_start = null
        this.course_end = null
        this.first_exam = null
        this.successful_exam = null
        this.kepzesi_preloader = true
        await this.gettoken()
        this.$http.post('/diakok/kepzesi/preview_220615', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: this.kepzesi_course_id
        }).then((response) => {
          this.kepzesi_preloader = false
          console.log(response.data);
          this.course_start = response.data['course_start']
          this.course_end = response.data['course_end']
          this.first_exam = response.data['first_exam']
          this.successful_exam = response.data['successful_exam']
          this.exam_place_code = response.data['exam_place_code']
          this.isArchived = response.data['isArchived']
          this.ConractStatus = response.data['Status']
        }, (error) => {
          this.error_text = error.data
        })
      },
      kepzesiPreviewKokeny: async function(course_student_id) {
        this.kepzesiStatus = false
        this.course_start = null
        this.course_end = null
        this.first_exam = null
        this.successful_exam = null
        this.kepzesi_preloader = true
        this.kepzesi_results = '';
        this.kepzesiStudDetails = '',
        await this.gettoken()
        this.$http.post('/kokeny/kepzesi_preview', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: this.kepzesi_course_id,
          course_student_id: course_student_id
        }).then((response) => {
          this.kepzesi_preloader = false
          this.isArchived = response.data['isArchived']
          this.ConractStatus = response.data['Status']
          this.kepzesiStudDetails = response.data['html']
          this.kepzesi_results = response.data['error_message']
          this.kepzesi_error = response.data['error']
          this.kokenyUgyId = response.data['UgyId']
          if (this.kepzesi_error == 'vanKepzesi') {
            this.kepzesiStatus = true;
          } else {
            this.kepzesiStatus = false;
          }
          console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      kepzesiAdatokCheck: async function(pallasz_id, kokeny_id, course_id, course_student_id, course_data_id) {
        this.course_data_id_toChange = course_data_id
        this.course_id_toChange = course_id
        this.email = '',
        this.VanKepzesiIgazolas = '';
        this.Athelyezett = '';
        this.kokenyUgyId = '';
        this.kav_tanulok = [];
        this.kepzesi_eredmenyek = [];
        this.gyakorlat = [];
        this.azonosito = '';
        this.UgyErvenyesseg = '';
        this.TanfolyamTipusString = '';
        this.TanfolyamKezdete = '';
        this.Kategoria = '';
        this.kepzesiStatus = '',
        this.kepzesi_reload = '',
        this.kepzesi_results = '';
        this.SikeresKozlIsmElmeletVizsgaIdeje = '',
        this.ElsoKozlIsmElmeletVizsgaIdeje = '',
        this.StudIdProblem = '';
        this.email_name = this.full_name
        this.kepzesi_preloader = true
        await this.gettoken()
          this.$http.post('/kokeny/kepzesi_adatok_check', {
            token: this.token,
            contract_id: this.contract_id,
            customer_id: this.customer_id,
            full_name: this.full_name,
            course_id: course_id,
            course_student_id: course_student_id
          }).then((response) => {
            this.kepzesi_preloader = false
            this.kav_tanulok = response.data;
            console.log(response.data);
          }, (error) => {
            this.error_text = error.data
          })
      },
      kepzesiAdatok: async function(UgyId, Athelyezett, VanKepzesiIgazolas, StudIdProblem) {
        this.VanKepzesiIgazolas = VanKepzesiIgazolas;
        this.Athelyezett = Athelyezett;
        this.kokenyUgyId = UgyId;
        this.StudIdProblem = StudIdProblem;
        this.kepzesi_preloader = true
        await this.gettoken()
        if (Athelyezett == true && VanKepzesiIgazolas) {
          this.$http.post('/kokeny/kepzesi_adatok_archiv', {
            token: this.token,
            contract_id: this.contract_id,
            customer_id: this.customer_id,
            UgyId: UgyId
          }).then((response) => {
            this.kepzesi_preloader = false     
            this.gyakorlat = response.data['gyakorlat'];
            this.azonosito = response.data['azonosito'];
            this.kepzesiStatus = response.data['kepzesi'];
            this.kepzesi_reload = response.data['kepzesi_reload'];
            this.TanfolyamKezdete = response.data['TanfolyamKezdete'];
            this.Kategoria = response.data['Kategoria'];
            this.isArchived = response.data['isArchived']
            this.UgyErvenyesseg = response.data['UgyErvenyesseg'];
            this.ConractStatus = response.data['Status']
            this.ElsoKozlIsmElmeletVizsgaIdeje = response.data['ElsoKozlIsmElmeletVizsgaIdeje']
            this.SikeresKozlIsmElmeletVizsgaIdeje = response.data['SikeresKozlIsmElmeletVizsgaIdeje']
            this.email = response.data['email']
            if (response.data['kepzesi_reload'] == false) {
              this.kepzesi_results = "Képzési igazolás újranyomtatása már nem lehetséges.";
            }
            console.log(response.data);
          }, (error) => {
            this.error_text = error.data
          })
        } else {
          this.$http.post('/kokeny/kepzesi_adatok', {
            token: this.token,
            contract_id: this.contract_id,
            customer_id: this.customer_id,
            UgyId: UgyId
          }).then((response) => {
            this.kepzesi_preloader = false
            this.kepzesi_eredmenyek = response.data['kepzesi_eredmenyek'];
            this.gyakorlat = response.data['gyakorlat'];
            this.azonosito = response.data['azonosito'];
            this.UgyErvenyesseg = response.data['UgyErvenyesseg'];
            this.TanfolyamTipusString = response.data['TanfolyamTipusString'];
            this.TanfolyamKezdete = response.data['TanfolyamKezdete'];
            this.Kategoria = response.data['Kategoria'];
            this.isArchived = response.data['isArchived']
            this.ConractStatus = response.data['Status']
            this.kepzesiStatus = response.data['kepzesi'];
            this.email = response.data['email']
            if (response.data['kepzesi'] == false) {
              this.kepzesi_results = "Képzési igazolás kiadása nem lehetséges.";
            }
            console.log(response.data);
          }, (error) => {
            this.error_text = error.data
          })
        }
      },
      kepzesiKiad: async function() {
        this.kepzesi_preloader = true
        this.saveKepzesiLoad = true
        await this.gettoken()
        this.$http.post('/kokeny/kepzesi_save_231026', {
          token: this.token,
          kokenyUgyId: this.kokenyUgyId,
          contract_id: this.contract_id
        }).then((response) => {
          this.kepzesi_preloader = false
          this.saveKepzesiLoad = false
          this.response_text = response.data['message'];
          if (response.data['result'] == 'success') {
            this.kepzesiAdatok(this.kokenyUgyId, true, true);
          } else {
            this.kepzesi_results = response.data['message'];;
          }
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      kepzesiSend: async function() {
        this.kepzesi_send = true
        await this.gettoken()
        this.$http.post('/kokeny/kepzesi_send', {
          token: this.token,
          kokenyUgyId: this.kokenyUgyId,
          contract_id: this.contract_id,
          email: this.email,
          email_name: this.email_name
        }).then((response) => {
          this.kepzesi_send = false
          this.response_text = response.data['message'];
          this.response_snackbar = true
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
      },
      downloadKepzesi: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/kepzesi/kepzesi', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: this.kepzesi_course_id,
          karton: this.karton,
          failed_exams: this.failed_exams,
          restrictions: this.restrictions,
          bu: this.bu,
          dp_a: this.dp_a,
          dp_fv: this.dp_fv,
          dp_fo: this.dp_fo,
          dp_fh: this.dp_fh,
          dp_fe: this.dp_fe,
          dp_fk: this.dp_fk,
          course_start: this.course_start,
          course_end: this.course_end,
          first_exam: this.first_exam,
          successful_exam: this.successful_exam,
          exam_place_code: this.exam_place_code
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadKepzesiKokeny: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/kepzesi_print.php', {
          token: this.token,
          kokenyUgyId: this.kokenyUgyId,
          contract_id: this.contract_id,
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf;base64'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
          //console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadBefogado: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/befogado_print', {
          token: this.token,
          kulsos_azonosito: this.kulsos_azonosito,
          vonalkod: this.vonalkod,
          contract_id: this.contract_id,
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf;base64'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
          //console.log(response.data);
        }, (error) => {
          this.error_text = error.data
        })
      },
      saveBefogado: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/kokeny/befogado_save', {
          token: this.token,
          kulsos_azonosito: this.kulsos_azonosito,
          vonalkod: this.vonalkod,
          contract_id: this.contract_id,
          course_data_id: this.course_data_id_toChange,
          payment: this.sel_payment,
          free_learning: this.free_learning
        }).then((response) => {
          this.dots_loading = false
          this.response_text = response.data['message'];
          this.befogado_stream = response.data['stream'];
          if (response.data['success'] == true) {
            this.tanulo_atvetel = false;
            this.atvetel_preview = '';
            this.getCourseDetails()
            this.befogado_dialog = false;
            this.befogado_print_dialog = true;
          } else {
            this.gki_snackbar = true  
          }
        }, (error) => {
          this.dots_loading = false
          this.preloader = false
          this.error_text = error.data
        })
      },
      befogadoPrint: async function() {
        this.downloading = true
        await this.gettoken()
        this.$http.post('/kokeny/befogado_print_250326', {
          token: this.token,
          kulsos_azonosito: this.kulsos_azonosito,
          vonalkod: this.vonalkod,
          befogado_stream: this.befogado_stream,
          contract_id: this.contract_id
        }, {responseType: 'blob'}).then((response) => {
          this.downloading = false
          //const extension = this.contract_url.split(".");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.full_name+'_befogado.pdf');
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadTolmacsos: async function(course_id) {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/nyomtatvanyok/tolmacsos', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: course_id
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadSzobeli: async function(course_id) {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/nyomtatvanyok/szobeli', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          course_id: course_id
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      downloadKedvezmeny: async function() {
        this.dots_loading = true
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/nyomtatvanyok/tamogatas', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }, {responseType: 'blob'}).then((response) => {
          this.dots_loading = false
          this.preloader = false
          //Create a Blob from the PDF Stream
          const file = new Blob(
          [response.data],
          {type: 'application/pdf'});
          //Build a URL from the file
          const fileURL = URL.createObjectURL(file);
          //Open the URL on new Window
          window.open(fileURL);
        }, (error) => {
          this.error_text = error.data
        })
      },
      etitanKatUpload: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/save_kat_tanulo_230419', {
          this.$http.post('/etitan/saveStudent', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv,
          kieg: null
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'reserved') {
            this.reserved_gki_studs = response.data['students'];
            this.reserved_kat_dialog = true
          } else {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanUsername: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/check_username', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.reserved_gki_studs = response.data['students'];
          this.username_dialog = true
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatUploadNew: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/save_new_kat_tanulo', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv
        }).then((response) => {
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanGKIUpload: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/save_gki_tanulo', {
          this.$http.post('/etitan/saveStudent', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv,
          kieg: false
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'reserved') {
            this.reserved_gki_studs = response.data['students'];
            this.reserved_gki_dialog = true
          } else {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanGKIUploadNew: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/save_new_gki_tanulo', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv
        }).then((response) => {
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKiegUploadNew: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/save_new_vizsgafelk', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv
        }).then((response) => {
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanGKIUpdate: async function(value) {
        this.titanId = value.titan_id;
        this.reserved_gki_dialog = false
        this.reserved_kieg_dialog = false
        this.reserved_kat_dialog = false
        await this.gettoken()
        this.$http.post('/diakok/etitan/update_gki_tanulo', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          titanId: this.titanId
        }).then((response) => {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/order_kat_tanulo_230419', {
        this.$http.post('/etitan/orderStudent', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          nyelv: this.nyelv,
          free_learning: this.free_learning,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titan_order_confirm = false
          this.etitan_dialog = false
        }, (error) => {
          this.titan_loading_bar = false
          console.log(error.data);
        })
      },
      etitanGKIOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderStudent', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          free_learning: this.free_learning,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.gki_order_confirm = false
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatPotOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/order_kat_potora_221006', {
        this.$http.post('/etitan/orderPotora_240429', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          nyelv: this.nyelv,
          free_learning: this.free_learning,
          kieg: false
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == '9plus_error') {
            this.response_text = response.data['message'];
            this.plus_pot_dialog = true;
          } else {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.etitan_dialog = false
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatPotOrder9Plus: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/order_kat_potora_9plus', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          nyelv: this.nyelv,
          free_learning: this.free_learning,
          student_id: this.course_student_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKiegPotOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderPotora_240429', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          nyelv: this.nyelv,
          free_learning: this.free_learning,
          kieg: true
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKiegTanfPotOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderKiegTanfPotora', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          free_learning: this.free_learning
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanGKIPotOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderGKIPotora', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment,
          free_learning: this.free_learning
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatKiegOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderKiegTanf', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          kieg_tanfolyam: this.sel_kieg_tanfolyam,
          payment: this.sel_payment,
          free_learning: this.free_learning
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanPostOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/post_order', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          payment: this.sel_payment
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titan_order_confirm = false
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanVfUpload: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/save_vizsgafelk_220318', {
          this.$http.post('/etitan/saveStudent', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv,
          euVf: this.euVf,
          kieg: true
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'reserved') {
            this.reserved_gki_studs = response.data['students'];
            this.reserved_kieg_dialog = true
          } else {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.titanId = response.data['titanId'];
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanVfOrder: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/orderKieg', {
        //this.$http.post('/diakok/etitan/order_vizsgafelk_220523', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selected_vizsgafelk: this.selected_vizsgafelk,
          payment: this.sel_payment,
          nyelv: this.nyelv,
          free_learning: this.free_learning,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titan_order_confirm = false
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanPayments: async function() {
        this.sel_payment = null
        this.free_learning = false
        this.prereg = false
        await this.gettoken()
        this.$http.post('/diakok/etitan/payments', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.titan_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      oktatasPayments: async function() {
        this.sel_payment = null
        this.free_learning = false
        this.prereg = false
        await this.gettoken()
        this.$http.post('/diakok/etitan/payments', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.titan_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKatStat: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/katStat_240429', {
        //this.$http.post('/diakok/etitan/kat_stat_20211019', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'error') {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
          } else {
            this.etitan_stat = response.data;
            this.elearning_haladas = response.data[0]['Haladas'];
            this.elearning_temakor = response.data[0]['Temakor'];
            this.etitan_haladasIdo = response.data[0]['learningHaladas'];
            this.etitan_learningStatus = response.data[0]['learningStatus'];
            this.etitan_stat_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanVfKatStat: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/vfKatStat', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'error') {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
          } else {
            this.etitan_stat = response.data;
            this.elearning_haladas = response.data[0]['Haladas'];
            this.elearning_temakor = response.data[0]['Temakor'];
            this.etitan_learningStatus = response.data[0]['learningStatus'];
            this.tanultIdo = response.data[0]['learningHaladas'];
            this.etitan_vf_stat_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanKiegKatStat: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/kieg_kat_stat', {
        this.$http.post('/etitan/vfKatStat', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          titan_course_data_id: this.titan_course_data_id
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'error') {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
          } else {
            this.etitan_stat = response.data;
            this.elearning_haladas = response.data[0]['Haladas'];
            this.elearning_temakor = response.data[0]['Temakor'];
            this.etitan_vf_stat_dialog = true
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanSaveStat: async function() {
        this.preloader = true
        await this.gettoken()
        this.$http.post('/diakok/etitan/save_stat', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          etitan_stat: this.etitan_stat,
          course_data_id: this.titan_course_data_id,
          course_id: this.titan_course_id
        }).then((response) => {
          this.preloader = false
          this.gki_snackbar = true
          this.response_text = response.data;
          this.getCourseDetails()
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanPenzugy: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/tanuloiPenzugy', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.etitan_befizetesek = response.data['befizetesek'];
          this.etitan_penzugy_dialog = true
        }, (error) => {
          this.titan_loading_bar = false
          console.log(error.data);
        })
      },
      etitanDelete: async function() {
        if(confirm("Biztosan törli az összerendelést?")) {
        this.preloader
        await this.gettoken()
        this.$http.post('/diakok/etitan/torles', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titanId = response.data['titanId'];
        }, (error) => {
          console.log(error.data);
        })
       }
      },
      etitanClose: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/close_course', {
        this.$http.post('/etitan/kepzesLezar', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          reason: this.titan_close_reason
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titanId = response.data['titanId'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModFunctions() {
        if (this.titan_data_mod == 1) {
          this.etitanEmailMod()
        } else if (this.titan_data_mod == 2) {
          this.etitanStudUpdate()
        } else if (this.titan_data_mod == 3) {
          this.etitanEmailSend()
        } else if (this.titan_data_mod == 4) {
          this.etitanModRequest()
        } else if (this.titan_data_mod == 5) {
          this.etitanAddressRequest()
        }
      },
      etitanEmailMod: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/emailModify', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          this.titan_loading_bar = false
          console.log(error.data);
        })
      },
      etitanEmailSend: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/email_send', {
        this.$http.post('/etitan/emailSend', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanStudUpdate: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/updateStudent', {
        //this.$http.post('/diakok/etitan/update_tanulo', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          nyelv: this.nyelv,
          selected_training_type: this.selected_training_type
        }).then((response) => {
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanPostOrderNew: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/utolagosRendeles', {
        //this.$http.post('/diakok/etitan/update_tanulo', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selected_training_type: this.selected_training_type,
          payment: this.sel_payment,
          free_learning: this.free_learning,
          selected_vizsgafelk: this.selected_vizsgafelk
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
          this.titan_order_confirm = false
          this.etitan_dialog = false
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModRequest: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/adatmodositas', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
            this.response_success = response.data['result'];
            if (response.data['result'] == 'error') {
              this.gki_snackbar = true
              this.response_text = response.data['message'];
            } else {
              this.titan_mod_request_dialog = true
              this.adatKerelmek = response.data['Data'];
            }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModRequestAllow: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/adatmodositasAllow', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selectedAdatKerelmek: this.selectedAdatKerelmek
        }).then((response) => {
          this.titan_mod_request_dialog = false
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.selectedAdatKerelmek = null;
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModRequestDeny: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/adatmodositasDeny', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selectedAdatKerelmek: this.selectedAdatKerelmek
        }).then((response) => {
          this.titan_mod_request_dialog = false
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.selectedAdatKerelmek = null;
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModRequestAllowAll: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/modify_request_allow_all', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanModRequestDenyOld: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/diakok/etitan/modify_request_deny', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
          if (response.data['result'] == 'more_requests') {
            this.titan_mod_request_dialog = true
            this.mod_text = response.data['message']['ModText'];
            this.all_requests = response.data['message']['all_requests'];
          } else {
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
          }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanAddressRequest: async function() {
        this.titanLoading()
        await this.gettoken()
        //this.$http.post('/diakok/etitan/address_request', {
          this.$http.post('/etitan/cimmodositas', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id
        }).then((response) => {
          this.titan_loading_bar = false
            this.response_success = response.data['result'];
            if (response.data['result'] == 'error') {
              this.gki_snackbar = true
              this.response_text = response.data['message'];
            } else {
              this.titan_address_request_dialog = true
              this.cimKerelmek = response.data['Data'];
            }
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanAddressRequestAllow: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/cimmodositasAllow', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selectedCimKerelmek: this.selectedCimKerelmek
        }).then((response) => {
          this.titan_address_request_dialog = false
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.selectedCimKerelmek = null;
        }, (error) => {
          console.log(error.data);
        })
      },
      etitanAddressRequestDeny: async function() {
        this.titanLoading()
        await this.gettoken()
        this.$http.post('/etitan/cimmodositasDeny', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          selectedCimKerelmek: this.selectedCimKerelmek
        }).then((response) => {
          this.titan_address_request_dialog = false
          this.titan_loading_bar = false
            this.gki_snackbar = true
            this.response_success = response.data['result'];
            this.response_text = response.data['message'];
            this.selectedCimKerelmek = null;
        }, (error) => {
          console.log(error.data);
        })
      },
      vdPayments: async function() {
        this.sel_vd = null
        this.free_exam = false
        await this.gettoken()
        this.$http.post('/diakok/vd_payments', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.vd_payments = response.data;
        }, (error) => {
          console.log(error.data);
        })
      },
      contractUpload: async function() {
        this.uploading = true
        // objektummá alakítjuk, mert a funkció több fájl feltöltésére lett írva alapvetően
        this.contract_to_upload = [this.contract_to_upload];

        let formData = new FormData();

        for( var i = 0; i < this.contract_to_upload.length; i++ ){
          let file = this.contract_to_upload[i];
          formData.append('files[' + i + ']', file);
        }

        formData.append('token', this.token);
        formData.append('contract_id', this.contract_id);

        console.log(formData);
        console.log(this.contract_to_upload);
        
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_upload',
          formData,
					{
						headers: {
								'Content-Type': 'multipart/form-data'
						}
					}).then((response) => {
            this.uploading = false
            this.checkUploadedFile()
            this.response_success = response.data['result'];
            this.gki_snackbar = true
            this.response_text = response.data['message'];
          console.log(response.data);
        }, (error) => {
          console.log(error.data);
        })
        
      },
      checkUploadedFile: async function() {
        this.contract_to_upload = null;
        this.contract_url = null;
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_upload_check', {
          token: this.token,
          contract_id: this.contract_id
        }).then((response) => {
          this.contract_url = response.data[0]['contract_url'];
        }, (error) => {
          console.log(error.data);
        })
      },
      downloadUploadedContract: async function() {
        this.downloading = true
        await this.gettoken()
        this.$http.post('/diakok/szerzodes/contract_download', {
          token: this.token,
          contract_id: this.contract_id,
          contract_url: this.contract_url
        }, {responseType: 'blob'}).then((response) => {
          this.downloading = false
          const extension = this.contract_url.split(".");
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', this.full_name+'_szerzodes_up.'+extension[1]);
          document.body.appendChild(link);
          link.click();
        }, (error) => {
          this.error_text = error.data
        })
      },
      getCategoryList: async function() {
        this.loading = true
        await this.gettoken()
        this.$http.post('/diakok/category_list', {
          token: this.token,
          school_id: this.school_id
        }).then((response) => {
          this.loading = false
          this.category_list = response.data
          this.kateg_mod = true;
        }, (error) => {
          console.log(error.data);
        })
      },
      changeCategory: async function() {
        this.change_loading = true
        await this.gettoken()
        this.$http.post('/diakok/change_category', {
          token: this.token,
          contract_id: this.contract_id,
          customer_id: this.customer_id,
          changed_kateg: this.changed_kateg,
          course_id: this.course_id_toChange
        }).then((response) => {
          this.change_kateg_confirm = false
          this.change_loading = false
          this.response_success = response.data['result'];
          this.response_text = response.data['message'];
        }, (error) => {
          console.log(error.data);
        })
      },
      titanLoading() {
        this.titan_loading_bar = true
        this.titan_loading = 0;

        clearInterval(this.interval)

        this.interval = setInterval(() => {
          if (this.titan_loading == 100) clearInterval(this.interval);
          this.titan_loading ++;
        }, 250)
      },
      validate () {
        this.$refs.gki_card_form.validate()
      },
      resetValidation () {
        this.$refs.gki_card_form.resetValidation()
      },
      check18(contract_date, birthdate) {
        var date1 = new Date(contract_date);
        var date2 = new Date(birthdate);
        var dateMinus18 = date1.setFullYear(date1.getFullYear() - 18);
        if (date2 <= dateMinus18) {
          return true;
        } else {
          return false;
        }
      },
    },
    mounted() {
      this.getCourseDetails()
    },
    watch: {
      contract_id() {
        this.karton = '-'
        this.failed_exams = '-'
        this.restrictions = '-'
        this.bu = false
        this.dp_a = '-'
        this.dp_fv = '-'
        this.dp_fo = '-'
        this.dp_fh = '-'
        this.dp_fe = '-'
        this.dp_fk = '-'
        if (this.diakok_tab == 2) {
          this.student_course_details = null
          this.gki_show = false
          this.getCourseDetails()
        }
      },
      diakok_tab: function (value) {
        if (value == 2) {
          this.student_course_details = null
          this.gki_show = false
          this.getCourseDetails()
        }
      },
      kartya_kiallitas_value(value) {
        if (value == '2') {
          this.kartya_atvetel_value = null
        }
      }
    },
    computed: {
        ...mapFields([
          'showing.preloader',
          'diakok_details.customer_id',
          'diakok_details.contract_id',
          'diakok_details.contract_type',
          'diakok_details.full_name',
          'diakok_details.student_course_details',
          'course_details.course_id',
          'course_details.nkh_course_type_id',
          'course_details.course_student_id',
          'course_details.course_data_id',
          'course_details.course_number',
          'course_details.training_type',
          'tanfolyamok.headcount_update',
          'diakok_details.diakok_tab',
          'diakok_details.titanId',
          'auth.admin',
          'auth.fbuser',
        ]),
        kartyaAtvetelRules: function () {
          if (this.kartya_kiallitas_value == '2') {
              return true
          } else if (this.kartya_kiallitas_value != '2' && this.kartya_atvetel_value != null) {
              return true
          } else {
              this.valid = false
              return "Kötelező mező!"
          }
        },
      },
  }
</script>

<style lang="css">
</style>
